import React      from 'react';
import classnames from 'classnames';

import { START } from 'pu-data/QuoteSteps';

import GerberFile         from 'pu-react/components/GerberFile';
import PartNumber         from 'pu-react/components/PartNumber';
import Revision           from 'pu-react/components/Revision';
import Quantities         from 'pu-react/components/Quantities';
import NumberLayer        from 'pu-react/components/NumberLayer';
import BoardSize          from 'pu-react/components/BoardSize';
import SilkscreenSide     from 'pu-react/components/SilkscreenSide';
import InstantQuote       from 'pu-react/components/InstantQuote';
import SpecialInstruction from 'pu-react/components/SpecialInstruction';
import { numberLayer }    from "../data/SelectOptions";

import SupplierSelected   from 'pu-react/components/SupplierSelected';
import ProductQuoteNumber from 'pu-react/components/ProductQuoteNumber';
import RowSelected        from 'pu-react/components/RowSelected';
import ColumnSelected     from 'pu-react/components/ColumnSelected';


export default (props) => {
  const projectInfoClass = classnames('row', { 'd-none': props.quoteStep === START });
  return (
    <div className="pcb-form-section">
      <div className="row">
        <div className="col-md-6">
          <GerberFile {...props} />
        </div>
        <div className="col-md-6 instant-quote-top">
          <InstantQuote {...props} typePrepareData="single" />
        </div>
      </div>
      <div className={projectInfoClass}>
        <div className="col-md-6">
          <PartNumber {...props} />
        </div>
        <div className="col-md-6">
          <Revision {...props} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Quantities {...props} required />
        </div>
        <div className="col-6 col-lg-12 col-xl-6">
          <NumberLayer {...props} options={numberLayer} />
        </div>
        <div className="col-6 col-lg-12 col-xl-6">
          <BoardSize {...props} required />
        </div>
        <div className="col-12">
          <div id="error_board_size" />
        </div>
        <div className="col col-xl-6">
          <SilkscreenSide {...props} />
        </div>
        <div className="col-12">
          <SpecialInstruction {...props} />
        </div>
      </div>
      <RowSelected {...props} />
      <ColumnSelected {...props} />
      <SupplierSelected {...props} />
      <ProductQuoteNumber {...props} />
    </div>
  )
};
